import { render, staticRenderFns } from "./DepartmentListSelectorDialog.vue?vue&type=template&id=6096d9e0&scoped=true&"
import script from "./DepartmentListSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./DepartmentListSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentListSelectorDialog.vue?vue&type=style&index=0&id=6096d9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096d9e0",
  null
  
)

export default component.exports